import React from 'react';
import { Section } from './ui/Section';
export function Bonuses() {
  const bonuses = [{
    icon: '🔥',
    title: 'Planificador Express de Clases',
    originalPrice: '12€',
    desc: 'Planifica una clase completa en menos de 10 minutos'
  }, {
    icon: '✅',
    title: 'Checklist Pre-Clase Pro',
    originalPrice: '10€',
    desc: 'Entra a sala siempre listo y con autoridad'
  }, {
    icon: '🗣️',
    title: 'Pack de 80 Frases Pro',
    originalPrice: '8€',
    desc: 'Corrige y motiva como un instructor de élite'
  }];
  return <Section variant="alt" data-id="element-74">
      <h2 className="font-display text-3xl md:text-4xl font-bold text-center mb-4 text-brand-title" data-id="element-75">
        🎁 BONOS INCLUIDOS GRATIS
      </h2>

      <p className="text-center text-orange-400 font-semibold mb-8 text-lg" data-id="element-76">
        (Solo durante el periodo de lanzamiento)
      </p>

      <div className="grid md:grid-cols-3 gap-6 mb-8" data-id="element-77">
        {bonuses.map((bonus, i) => <div key={i} className="bg-gradient-card border border-brand-borderGlow/20 rounded-2xl p-6 text-center shadow-violet-glow hover:shadow-gold-glow transition-all hover:border-brand-gold/30" data-id="element-78">
            <div className="text-4xl mb-4" data-id="element-79">{bonus.icon}</div>
            <h3 className="font-heading text-lg font-bold text-brand-subtitle mb-2 tracking-wide" data-id="element-80">
              {bonus.title}
            </h3>
            <div className="mb-3" data-id="element-81">
              <span className="text-brand-textMuted line-through text-sm" data-id="element-82">
                {bonus.originalPrice}
              </span>
              <span className="text-brand-gold font-bold text-xl ml-2" data-id="element-83">
                → GRATIS
              </span>
            </div>
            <p className="font-body text-brand-text text-sm" data-id="element-84">{bonus.desc}</p>
          </div>)}
      </div>

      <div className="bg-gradient-card border border-brand-gold/30 rounded-2xl p-6 max-w-2xl mx-auto text-center shadow-gold-glow" data-id="element-85">
        <p className="font-heading text-brand-subtitle font-bold text-lg" data-id="element-86">
          Valor total de bonos:{' '}
          <span className="text-brand-textMuted line-through" data-id="element-87">30€</span>
          <span className="text-brand-gold ml-2" data-id="element-88">· Hoy: 0€</span>
        </p>
      </div>
    </Section>;
}